import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { ErrorBanner } from '../components/ui/ErrorBanner';
import { LoadingState } from '../components/ui/LoadingState';
import { useAuth } from './AuthProvider';
import { saveReturnTo } from './returnTo';

/** Renders its children only for a signed-in learner; otherwise sends them to sign in. */
export const RequireAuth: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const { state, refresh } = useAuth();
  const location = useLocation();

  if (state.status === 'loading') {
    return <LoadingState variant="full-page" message="Loading…" />;
  }
  if (state.status === 'error') {
    return (
      <ErrorBanner
        variant="full-page"
        message="We couldn't reach the server."
        onRetry={() => void refresh()}
      />
    );
  }
  if (state.status === 'signed-out') {
    // Remember where they were headed, unless they just chose to sign out.
    if (!state.deliberate) {
      saveReturnTo(`${location.pathname}${location.search}`);
    }
    return <Navigate to="/sign-in" replace />;
  }
  return <>{children}</>;
};

export default RequireAuth;
